module.exports = __webpack_public_path__ + "media/images/main_logo-89ca3298.png";